import axios from 'axios'
import jwt_decode from 'jwt-decode'
import store from '@/store'
const request = axios.create({
  baseURL: 'https://api-website.hire3x.com/', // Development
})
const register = axios.create({
  // baseURL: 'https://candidate-api.simplifycv.com', // Base URL for the API
  baseURL: "https://candidate-api.hire3x.com", // Base URL for the API
  headers: {
    'Content-Type': 'application/json', // Default header
  },
})
const ServiceCandidate = axios.create()

ServiceCandidate.interceptors.request.use((config) => {
  const hasAccess = store.getters['userVUEX/getCandAccess']
  config.baseURL = hasAccess
    ? 'https://gateway.hire3x.com/candidate/'
    : 'https://candidate-api.hire3x.com'

  return config
})

ServiceCandidate.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return error
  },
)

let refreshAccessToken;
ServiceCandidate.interceptors.response.use(
	(response) => response,
	async (error) => {
		if (
			(error.response.status == 403 || error.response.status == 401)) {
			if (!refreshAccessToken) {
				const module = await import("./apiFunction");
				refreshAccessToken = module.refreshAccessToken;
			}
			await refreshAccessToken();
			const token = getToken();
			if (token) {
				error.config.headers["Authorization"] = "Bearer " + token;
			}
			return axios(error.config);
		}
		return error.response || Promise.reject(error);
	}
);

const KeynodeService = axios.create({
  baseURL: 'https://keynode.hire3x.com/',
})
const SSOService = axios.create({
  // baseURL: 'http://auth.simplifycv.com/', // Development
  baseURL: "https://auth.hire3x.com/", // Staging & Development
})

const websiteRequest = axios.create({
  // baseURL: 'https://api-website.simplifycv.com/',
  baseURL: "https://api-website.hire3x.com/",
  // baseURL: "https://api-website.hire3x.com/",
})

const prefRequest = axios.create({
  // baseURL: 'https://api-website.simplifycv.com/',
  // baseURL: "https://api-website.simplifymycareer.com/",
  baseURL: "https://api-website.hire3x.com/",
})

const websiteCareerpageRequest = axios.create({
  baseURL: 'https://api-website.hire3x.com/',
  // baseURL: "https://api-website.hire3x.com/",
})

const conv = axios.create({
  // baseURL: "https://convert.hire3x.com/",
  // baseURL: 'https://recruitment-api.simplifycv.com/',
  baseURL: "https://recruitment-api.hire3x.com/",
  // baseURL : "http://localhost:5001/"
})

conv.interceptors.request.use((config) => {
  const hasAccess = store.getters['userVUEX/getCandAccess']
	config.baseURL = hasAccess
		? "https://gateway.hire3x.com/recruitment/"
		: "https://recruitment-api.hire3x.com/";

	// Uncomment the line below for local backend testing
	// config.baseURL = "http://127.0.0.1:8000/";

	return config;
});

conv.interceptors.request.use(
	(config) => {
		const token = getToken();
		if (token) {
			config.headers["Authorization"] = "Bearer " + token;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

conv.interceptors.response.use(
	(response) => response,
	async (error) => {
		if (
			(error.response.status == 403 || error.response.status == 401)) {
			if (!refreshAccessToken) {
				const module = await import("./apiFunction");
				refreshAccessToken = module.refreshAccessToken;
			}
			await refreshAccessToken();
			const token = getToken();
			if (token) {
				error.config.headers["Authorization"] = "Bearer " + token;
			}
			return axios(error.config);
		}
		return error.response || Promise.reject(error);
	}
);

const resumeParser = axios.create({
  // baseURL: "https://resumeparser.hire3x.com",
  baseURL: 'https://resumeparser.hire3x.com',
})

const requestSuggestion = axios.create({
  // baseURL: 'https://suggestions.simplifycv.com/',
  baseURL: 'https://suggestions.hire3x.com/',
})
websiteRequest.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = 'Bearer ' + getToken()
    // config.headers["userID"] = getProcessedToken();

    return config
  },
  (error) => {
    // Do something with request error
    return error
  },
)

prefRequest.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = 'Bearer ' + getToken()
    config.headers['userID'] = getProcessedToken()
    // config.headers["userID"] = "5b935330-0f65-4492-b158-5e3e7b9b8bd4";
    // config.headers["userID"] = "e562e893-3ed8-4073-9576-10373bc3e260";

    return config
  },
  (error) => {
    // Do something with request error
    return error
  },
)

function getProcessedToken() {
  if (getToken()) {
    try {
      var decoded = jwt_decode(getToken())
      return decoded.sub
    } catch (e) {
      console.error('Invalid token', e)
      return null
    }
  }
  return null
}
// Get token from cookie
const getToken = () => {
  let data = document.cookie.split(';')
  for (let i in data) {
    let cur = data[i].split('=')
    if (cur[0].trim() === 'accessToken') {
      return cur[1]
    }
  }
}

const trainingService = axios.create({
  baseURL: 'https://training-api.hire3x.com/',
})

export {
  getProcessedToken,
  request,
  SSOService,
  websiteRequest,
  prefRequest,
  conv,
  resumeParser,
  ServiceCandidate,
  register,
  websiteCareerpageRequest,
  requestSuggestion,
  KeynodeService,
  trainingService,
}
